// extracted by mini-css-extract-plugin
module.exports = {"light":"TaskItem_light__Ra-do","dark":"TaskItem_dark__2CvIi","completed":"TaskItem_completed__1qQ7S"};